
import React, { Component } from 'react';
//import { ethers } from "ethers";
//import { Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import Navbar from './components/navbar';
import Web3 from 'web3';

import './App.css'
import "./styles/globals.css";
import detectEthereumProvider from '@metamask/detect-provider';
//import { getwebUri } from "./utils/interact.js";
import { METAMALL_ABI, METAMALL_ADDRESS } from './config'
import About from "./components/about";
//import UrlComponent from "./components/UrlComponent";
import Main from './components/main'




//export const mynftList = [];

//import { encrypt } from 'eth-sig-util'
//import MetaMaskOnboarding from '@metamask/onboarding'

export function gonder() {
  return "test";
}

class App extends Component {



  async componentDidMount() {
    // Asking if metamask is already present or not
    /*
    if (window.ethereum) {
      console.log('Got the ethereum obejct: ', window.ethereum.isMetaMask)
      // res[0] for fetching a first wallet
      this.loadBlockchainData()
    } else {
      alert("install metamask extension!!");
    }
*/
    this.loadBlockchainData()
    // console.log("url : ", this.state.mynftList);
  }

  async loadBlockchainData() {


    //Metamask var mı bakıyoruz
    const provider = await detectEthereumProvider()
    //metamask kurulu
    if (provider) {

      console.log('Ethereum successfully detected!')

      this.setState({ metamaskVar: true })
      const web3 = new Web3(Web3.givenProvider)
      //console.log("web3 :", web3)

      //metamask seçili ağı alalım
      const network = await web3.eth.net.getNetworkType()
      this.setState({ network: network })
      /*
          if (network === 'main') { alert("Ethereum Mainnete Bağlısınız.") }
          else if (network === 'rinkeby') { //alert("Ethereum Rinkeby Test Ağına Bağlısınız.")
          }
          */
      console.log("Network : ", network)

      // Seçili ağın ID si
      const chainId = await provider.request({ method: 'eth_chainId' });
      console.log("chainId: ", chainId)

      //seçili ağa bağlı hesapları alalım
      const accounts = await web3.eth.getAccounts()
      this.setState({ cuzdanAdresi: accounts[0] })
      console.log("Bağlı Hesap :", accounts[0])

      //cuzdandaki eth miktarı
      const miktar = await web3.eth.getBalance(accounts[0])
      console.log("miktar: ", miktar)
      this.setState({ cuzdandakiMiktar: miktar })

      //şimdi deploy edilmiş smart contract bilgilerimizi alalım
      const Metamask = new web3.eth.Contract(METAMALL_ABI, METAMALL_ADDRESS)
      this.setState({ Metamask })
      console.log("Metamaskkkk : ", Metamask.methods)
      const maxtoken = await Metamask.methods.MAX_TOKENS().call()
      console.log("MaxToken :", maxtoken);
      const price = await Metamask.methods.token_Price().call()
      const preprice = await Metamask.methods.token_prePrice().call()
      const sahip = await Metamask.methods.owner().call()
      const enfazlaalim = await Metamask.methods.maxTokenPurchase().call()
      const enfazlaprealim = await Metamask.methods.presaleMaxMint().call()
      console.log("sahip : ", sahip);
      console.log("En fazla sale ile alım : ", enfazlaalim);
      console.log("En fazla presale ile alım : ", enfazlaprealim);
      this.setState({ maxgettokenSale: enfazlaalim })
      this.setState({ maxgettokenpreSale: enfazlaprealim })
      this.setState({ maxtoken: maxtoken })
      this.setState({ preprice: preprice })
      this.setState({ price: price })
      this.setState({ sahip: sahip })
      //hesabın sahip olduğu nft ler
      const mynfts = await Metamask.methods.tokensOfOwner(accounts[0]).call()
      console.log("nft lerim : ", mynfts);
      console.log("nft lerimin sayısı : ", mynfts.length);
      this.setState({ nftsayim: mynfts.length })
      //for (let i = 0; i < mynfts.length; i++) {
      for (let i = 0; i < 10; i++) {
        const urr = await Metamask.methods._getwebURI(mynfts[i]).call()
        this.setState({ mynftList: [...this.state.mynftList, { id: mynfts[i], image: "/images/metamall.gif", url: urr }] },
          function () {
            console.log("setState completed mynft URLS:", this.state.mynftList)
          })

      }
      // console.log("url : ", this.state.mynftList);

      const satisAktifmi = await Metamask.methods.saleIsActive().call();
      this.setState({ satisAktifmi: satisAktifmi })
      const onsatisAktifmi = await Metamask.methods.presaleIsActive().call();
      this.setState({ onsatisAktifmi: onsatisAktifmi })
      console.log("Ön Satış Aktif mi ? :", onsatisAktifmi)
      const totalSupply = await Metamask.methods.totalSupply().call();
      this.setState({ toplamSatilan: totalSupply })
      //  alert("Toplam Satılan :" + totalSupply)
      this.setState({ loading: false })

    } else {
      // if the provider is not detected, detectEthereumProvider resolves to null
      alert('Please install MetaMask!')
    }
    // console.log("url : ", this.state.mynftList);

  }

  constructor(props) {
    super(props)
    this.state = {
      metamaskVar: false,
      network: '',
      cuzdanAdresi: '',
      cuzdandakiMiktar: 0.00,
      sahip: '',
      nftsayim: 0,
      maxgettokenSale: 0,
      maxgettokenpreSale: 0,
      maxtoken: 0,
      price: 0,
      preprice: 0,
      mynftList: [],
      loading: true,
      satisAktifmi: false,
      onsatisAktifmi: false,
      toplamSatilan: 0,

    }
    this.urlDegis = this.urlDegis.bind(this);
    this.saleMint = this.saleMint.bind(this);
    this.presaleMint = this.presaleMint.bind(this);
  }

  async urlDegis(id, url) {
    let obj = this.state.mynftList.find(o => o.id === id);

    console.log("bulundu:", obj);

    if (!obj) {
      alert("This token is not yours!")
      return;
    }
    this.setState({ loading: true })
    //deneme amaçlı bir nft nin url adresini değişelim
    const web3 = new Web3(Web3.givenProvider)
    const Metamask = new web3.eth.Contract(METAMALL_ABI, METAMALL_ADDRESS)
    const accounts = await web3.eth.getAccounts()
    //alert("url:", url)
    await Metamask.methods.changeweburl(id, url).send({ from: accounts[0], gasLimit: "" })
      .once('receipt', (receipt) => {
        this.setState({ mynftList: [] })
        this.loadBlockchainData()
        this.setState({ loading: false })
        console.log("DATA :", receipt.data)
      }).on('error', (err) => {
        if (err.code === 4001) alert("User denied transaction signature.")
        if (err.code === -32603) alert("Intrinsic gas too low.")
        //       console.log("hATA :", JSON.stringify(err.receipt))
        this.setState({ loading: false })
      })
  }

  async saleMint(adet) {
    /*
        if (this.state.maxgettokenSale < (adet + this.state.nftsayim)) {
          alert("You have " + this.state.nftsayim + " Nft now. Can have " + this.state.maxgettokenSale + " nft in total!")
          return
        }
        */
    this.setState({ loading: true })
    //deneme amaçlı bir nft nin url adresini değişelim
    const web3 = new Web3(Web3.givenProvider)
    const Metamask = new web3.eth.Contract(METAMALL_ABI, METAMALL_ADDRESS)
    const accounts = await web3.eth.getAccounts()
    console.log("accounts[0]:", accounts[0])

    //const fiyat = parseInt(web3.utils.toWei(this.state.price, "ether") * adet).toString(16);
    let fiyat = this.state.price * adet.toString();
    if (this.state.sahip === accounts[0]) fiyat = 0;
    console.log("fiyat", fiyat)
    await Metamask.methods.mintNft(adet).send({ from: accounts[0], value: fiyat, gasLimit: "" })
      .once('receipt', (receipt) => {
        this.setState({ mynftList: [] })
        this.loadBlockchainData()
        this.setState({ loading: false })
      }).on('error', (err) => {
        if (err.code === 4001) alert("User denied transaction signature.")
        if (err.code === -32603) alert("Intrinsic gas too low.")
        console.log("hATA :", JSON.stringify(err.receipt))
        this.setState({ loading: false })
      })

  }

  async presaleMint(adet) {
    this.setState({ loading: true })

    const web3 = new Web3(Web3.givenProvider)
    const Metamask = new web3.eth.Contract(METAMALL_ABI, METAMALL_ADDRESS)
    const accounts = await web3.eth.getAccounts()
    console.log("accounts[0]:", accounts[0])
    const preListtemi = await Metamask.methods.onPreSaleList(accounts[0]).call()
    console.log("preListtemi :", preListtemi)
    if (preListtemi) {
      //const fiyat = parseInt(web3.utils.toWei(this.state.price, "ether") * adet).toString(16);
      let fiyat = this.state.preprice * adet.toString();
      if (this.state.sahip === accounts[0]) fiyat = 0;
      console.log("fiyat", fiyat)
      await Metamask.methods.premintNft(adet).send({ from: accounts[0], value: fiyat, gasLimit: "" })
        .once('receipt', (receipt) => {
          this.setState({ mynftList: [] })
          this.loadBlockchainData()
          this.setState({ loading: false })
        }).on('error', (err) => {
          if (err.code === 4001) alert("User denied transaction signature.")
          if (err.code === -32603) alert("Intrinsic gas too low.")
          console.log("hATA :", JSON.stringify(err.receipt))
          this.setState({ loading: false })
        })
    } else {
      alert("You must on the Presale List !, Please visit our twitter address.")
      this.setState({ loading: false })
    }
  }


  render() {
    return (
      <div className="container" >

        <Navbar account={this.state.cuzdanAdresi} />

        <div className="mx-auto p-1" >
          <br /><br />
          <h1 className="text-center m-auto font-bold">Welcome to Metamall Nft Project!</h1>
        </div>
        <About />
        <div className="container">
          <div className="text-center m-auto">

            <main role="main">
              {this.state.loading
                ? <div id="loader" className="text-center"><h2>Loading...  Please Wait !</h2></div>
                :
                <Main mynftList={this.state.mynftList}
                  satisAktifmi={this.state.satisAktifmi}
                  onsatisAktifmi={this.state.onsatisAktifmi}
                  totalSupply={this.state.toplamSatilan}
                  urlDegis={this.urlDegis}
                  saleMint={this.saleMint}
                  presaleMint={this.presaleMint}
                />
              }
            </main>
          </div>
        </div>
      </div>

    );
  }
}

export default App;
